module.exports = __webpack_public_path__ + "static/img/solve4.1800a4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/solve4.png
// module id = cI19
// module chunks = 1